module.exports = __webpack_public_path__ + "img/kid-item3.9fb2707e.png";